import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DefaultLayout from '../components/DefaultLayout';
import { Col, Row } from 'antd';
import { Routes, Route, Link, useNavigate, Outlet  } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { Layout, Menu } from 'antd';
import '../admin.css';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    UsergroupAddOutlined,
    HomeOutlined,
    CarOutlined,
    CopyOutlined,
    UnorderedListOutlined,
    LoginOutlined
} from '@ant-design/icons';
import Cars from './Cars';
import AddCar from './AddCar';
import Bookings from './Bookings';
import Customers from './Customers';
import EditCar from './EditCar';
  
const { Header, Sider, Content } = Layout;
  
const AdminHome = () => {

    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
  
    useEffect(() => {
        if (!user.isAdmin) {
            window.location.href = '/home';
        }
    }, []);

    const { loading } = useSelector((state) => state.alerts);
    const [collapsed, setCollapsed] = useState(false);
    
    const toggle = () => {
        setCollapsed(!collapsed);
    };

    return (
        <DefaultLayout>

            { loading == true && <Spinner /> }


            <Row justify="center" gutter={16} className="mt-2">
                <Col lg={16} sm={24}>
                    <div className="d-flex justify-content-center align-items-center">
                        <h3 className="mt-2 mr-2"><span><strong>Admin Panel</strong></span></h3>
                    </div>
                </Col>
            </Row>

            <Layout>
                <Sider trigger={null} collapsible collapsed={collapsed}>
                    <div className="logo">
                        <h3>{collapsed ? 'Admin' : user?.name}</h3>
                    </div>
                    
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={window.location.pathname}
                    >
                        <Menu.Item key="/home" icon={<HomeOutlined />}>
                            <Link to="/home">Home</Link>
                        </Menu.Item>

                        <Menu.Item key="/admin" icon={<UserOutlined />}>
                            <Link to="/admin">Admin</Link>
                        </Menu.Item>

                        <Menu.Item key="/cars" icon={<CarOutlined />}>
                            <Link to="/admin/cars">Cars</Link>
                        </Menu.Item>

                        <Menu.Item key="/users" icon={<UsergroupAddOutlined />}>
                            <Link to="/admin/customers">Users</Link>
                        </Menu.Item>

                        <Menu.Item key="/bookings" icon={<CopyOutlined />}>
                            <Link to="/admin/bookings">Bookings</Link>
                        </Menu.Item>

                        <Menu.Item key="/more" icon={<UnorderedListOutlined />}>
                            <Link to="/admin">More</Link>
                        </Menu.Item>

                        <Menu.Item key="/logout" icon={<LoginOutlined />} onClick={()=>{
                            localStorage.removeItem('user');
                            navigate('/login');
                        }}>
                            Logout
                        </Menu.Item>

                    </Menu>

                </Sider>
                <Layout className="site-layout">

                    <Header className="site-layout-background" style={{ padding: 10 }}>
                        {React.createElement(
                            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                            {
                                className: 'trigger',
                                onClick: toggle,
                            }
                        )}
                        <div
                            className="d-flex align-items-center"
                            onClick={() => navigate('/admin')}>
                            
                            <strong>
                                {' '}
                                <span><strong><p className="mt-3 mr-2">Admin</p></strong></span>
                            </strong>
                            <span><CarOutlined /></span>
                        </div>

                    </Header>

                    <Content
                        className="site-layout-background"
                        style={{
                            margin: 10,
                            padding: 1,
                            minHeight: 280
                        }}>

                        <Row justify="center" gutter={24} className='p-3 content'>
                        
                            <Col lg={24} sm={24} xs={24} className='tabs'>
                                <ul className="adminfunctions">
                                    <li className='active'>
                                        <Link to={'/admin/cars'} style={{color: 'white'}}>Cars List</Link>
                                    </li>
                                    <li>
                                        <Link to={'/admin/customers'} style={{color: 'white'}}>Users List</Link>
                                    </li>

                                    <li>
                                        <Link to={'/admin/bookings'} style={{color: 'white'}}>Bookings</Link>
                                    </li>
                                    <li>
                                        <Link to={'/admin/addcar'} style={{color: 'white'}}>Add Car</Link>
                                    </li>
                                </ul>
                            
                                <Routes>
                                    <Route path="/admin/cars" element={<Cars />} />
                                    <Route path="/admin/customers" element={<Customers />} />
                                    <Route path="/admin/bookings" element={<Bookings/>} />
                                    <Route path="/admin/addcar" element={<AddCar/>} />
                                    <Route path='/admin/editcar/:carid' element={<EditCar/>} />
                                </Routes>

                                <Outlet />

                            </Col>
                        </Row>
                    </Content>
                </Layout>        
            </Layout>

                
            
        </DefaultLayout>
    );
};

export default AdminHome;

